import { PostRequestOptions, PostSource, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { postCompositionConfigSinglePost } from '../../components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export const WidgetPostsSinglePost: Widget = {
    type: 'postsSinglePost',
    id: 'single-post',
    name: 'Single Post',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    postRequests: [
        {
            sources: [
                {
                    type: 'posts',
                    // Note: All global variables like reportingEngine, report, and filters
                    // are injected via PostRequest.getRequests()
                    id: new PostSource({
                        pageSize: 6,
                        sorts: [
                            new Sort({
                                order: 'DESC',
                                heading: {
                                    MONITORING_DASHBOARD: 'REACH_COUNT',
                                    LISTENING: 'REACH_COUNT',
                                    INBOUND_MESSAGE: 'INBOUND_COUNT',
                                    PLATFORM: 'TOTAL_ENGAGEMENT',
                                    BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                    CAMPAIGN: 'OUTBOUND_STATUS',
                                    RDB_FIREHOSE: 'SN_CREATED_TIME',
                                    STORY_MESSAGE: 'IMPACT',
                                },
                            }),
                        ],
                        includeComments: true,
                        showInReplyToPost: false,
                        timePeriod: {
                            key: 'last_7_days',
                        },
                    }) as any,
                    options: new PostRequestOptions(
                        {
                            MONITORING_DASHBOARD: {
                                ignoreTimePeriod: true,
                            },
                        },
                        {
                            count: 200,
                            imagePreload: true,
                            removeDuplicates: true,
                            shufflePosts: false,
                            removeSensitivePosts: true,
                            includeQuoteTweets: false,
                        }
                    ) as any,
                },
            ],
            format: {
                type: 'window',
                options: {
                    padding: 1,
                },
            },
        },
    ],
    position: DefaultWidgetPosition,
    options: {
        player: {
            playing: true,
            duration: 6,
        },
        postVersion: 2,
        nativeStyling: {
            retweetIndicator: true,
        },
        ...postCompositionConfigSinglePost.a,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
    label: {
        titleText: 'Single Post',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
};
